import {LangIdMap} from "~/config/language";

export const DefaultTemplate = {
  header: {
    textColor: '#000',
    textColorShow: true
  },
  carousel: {
    hasTitle: true,
    hasDescribe: true,
    banner1: 'https://kopglobal.com/site-builder/prod/public/1687673372964_banner1.png',
    banner2: 'https://kopglobal.com/site-builder/prod/public/1687673653090_1686911784580_22.png'
  },
  pwa: {
    title: `<p><span class="ql-size-large">${LangIdMap.PwaTitle}</span></p>`
  },
  store: {
    title: `<h1 class="ql-align-center"><span style="color: rgb(0, 0, 0);">${LangIdMap.StoreTitle}</span></h1>`,
    goodsType: '1',
    goodsGroup: '',
    goodsTitle: {
      color: 'rgba(219, 189, 104, 1)'
    },
    priceColor: 'rgba(255, 255, 255, 1)',
    buyBackground: {
      backgroundColor: 'rgba(0, 0, 0, 1)'
    },
    goodsBackground: {
      color: 'rgba(255, 255, 255, 1)'
    },
    logoBackground: {
      backgroundColor: 'rgba(234, 195, 72, 1)'
    }
  },
  imageText: {
    title: `<h1 class="ql-align-center">${LangIdMap.ImageTextTitle}</h1>`
  },
  StoreV2: {
    title: `<h1 class="ql-align-center"><span style="color: rgb(0, 0, 0);">${LangIdMap.StoreV2Title}</span></h1>`
  },
  rechargeV1: {
    title: `<h1 class="ql-align-center"><span class="ql-size-large">充值活动</span></h1>`,
    subtitle: `<h1 class="ql-align-center"><span class="ql-size-large">多买多送</span></h1>`
  },
  rechargeV2: {
    title: `<h1 class="ql-align-center"><span style="color: rgb(0, 0, 0);">${LangIdMap.RechargeV2Title}</span></h1>`,
    describe: `<h5 class="ql-align-center"><span style="color: rgb(183, 183, 183);">${LangIdMap.RechargeV2Subtitle}</span></h5>`,
  },
  activity: {
    title: `<h1 class="ql-align-center">${LangIdMap.ActivityTitle}</h1>`,
    subtitle: `<h2 class="ql-align-center"><span style="color: rgb(183, 183, 183);">${LangIdMap.ActivityDesc}</span></h2>`,
    ruleTitle: `<h2 class="ql-align-center">${LangIdMap.ActivityRuleTitle}</h2>`,
    ruleDescribe: `<h5 class="ql-align-left"><span style="color: rgb(183, 183, 183);">${LangIdMap.ActivityRuleDesc}</span></h5>`,
    innerBackground: {
      backgroundColor: '#00CD85',
    },
    progressBackground: {
      backgroundColor: '#d6d6d6',
    },
    disabledBackground: {
      backgroundColor: '#a3a3a3',
    },
    getBackground: {
      backgroundColor: '#000'
    },
    logoBackground: {
      backgroundColor: '#DBBD68',
    },
    cardBackground: {
      backgroundColor: '#FFFFFF',
    },
    buttonTextColor: {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
    background: {
      backgroundColor: '#f4f4f4',
    },
    textColor: {
      backgroundColor: 'rgba(0, 0, 0, 1)'
    }
  },
  lottery: {
    title: `<h1 class="ql-align-center">${LangIdMap.ActivityTitle}</h1>`,
    subtitle: `<h5 class="ql-align-center">${LangIdMap.ActivityDesc}</h5>`,
    rule: {
      title: `<p class="ql-align-center"><span style="color: rgb(0, 0, 0)" class="ql-size-large">kop-128</span></p>`
    },
    history: {
      title: `<p class="ql-align-center"><span style="color: rgb(0, 0, 0)" class="ql-size-large">kop-121</span></p>`
    }
  },
  convertKey: {
    title: `<h1 class="ql-align-center">${ LangIdMap.ConvertKeyTitle }</h1>`,
    desc: `<h5 class="ql-align-center" style="color: rgb(183, 183, 183);">${ LangIdMap.ConvertKeySubtitle }</h5>`
  },
  missionCenter: {
    title: `<h2 class="ql-align-center">${ LangIdMap.MissionCenterTitle }</h2>`
  },
  consecutive: {
    title: `<h1 class="ql-align-center">${LangIdMap.ConsecutiveTitle}</h1>`,
    subtitle: `<h5 class="ql-align-center" style="color: rgb(183, 183, 183);">${LangIdMap.ConsecutiveSubtitle}</h5>`,
    innerBackground: {
      backgroundColor: '#00CD85',
    },
    progressBackground: {
      backgroundColor: '#d6d6d6',
    },
    disabledBackground: {
      backgroundColor: '#a3a3a3',
    },
    getBackground: {
      backgroundColor: '#000'
    },
    logoBackground: {
      backgroundColor: '#DBBD68',
    },
    cardBackground: {
      backgroundColor: '#FFFFFF',
    },
    buttonTextColor: {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
    background: {
      backgroundColor: '#f4f4f4',
    },
    textColor: {
      backgroundColor: 'rgba(0, 0, 0, 1)'
    }
  },
  collapse: {
    background: 'rgba(198, 209, 178, 0.38)',
    title: `<h1 class="ql-align-center" style="color: rgb(102, 185, 102);">${LangIdMap.CollapseTitle}</h1>`,
    row: {
      title: `<p>${LangIdMap.ImageTextTitle}</p>`,
      describe: `<p class="ql-align-center">${LangIdMap.ImageTextDesc}</p>`
    }
  },
  monthCard: {
    title: `<h1 class="ql-align-center"><span>${LangIdMap.MonthCardTitle}</span></h1>`,
    subtitle: `<h5 class="ql-align-center"><span style="color: rgb(183, 183, 183);">${LangIdMap.MonthCardSubtitle}</span></h5>`,
    rule: {
      title: `<p class="ql-align-center"><span style="color: rgb(0, 0, 0)" class="ql-size-large">kop-128</span></p>`
    },
    cover: {
      backgroundColor: '#DBBD68'
    },
    coverBackground: {
      backgroundColor: '#ededec'
    },
    cardBackground: {
      backgroundColor: 'rgba(255, 255, 255, 0.86)'
    },
    prizeBackground: {
      backgroundColor: '#DBBD68'
    },
    prizeNumber: {
      backgroundColor: 'rgba(255, 255, 255, 1)'
    },
    prizeNumberBackground: {
      backgroundColor: 'linear-gradient(270deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.56) 52%, rgba(0, 0, 0, 0.2) 100%)'
    },
    buttonBackground: {
      backgroundColor: 'rgba(0, 0, 0, 1)'
    },
    buttonColor: {
      backgroundColor: 'rgba(255, 255, 255, 1)'
    },
    getBackground: {
      backgroundColor: '#DBBD68'
    },
    getColor: {
      backgroundColor: 'rgba(255, 255, 255, 1)'
    },
    textColor: {
      backgroundColor: 'rgba(0, 0, 0, 1)'
    },
    modalBackground: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)'
    },
    receiveBackground: {
      backgroundColor: '#DBBD68'
    },
    receiveColor: {
      backgroundColor: 'white'
    }
  },
  singleGoods: {
    title: `<h1 class="ql-align-center"><span>${LangIdMap.singleGoodsTitle}</span></h1>`,
    subtitle: `<h5 class="ql-align-center"><span style="color: rgb(183, 183, 183);">${LangIdMap.singleGoodsSubtitle}</span></h5>`,
  },
  storeList: {
    title: `<h1 class="ql-align-center"><span>${LangIdMap.StoreListTitle}</span></h1>`,
    subtitle: `<h5 class="ql-align-center"><span>${LangIdMap.StoreListSubtitle}</span></h5>`,
    btnBackground: {
      backgroundColor: 'linear-gradient(111deg, rgb(235, 196, 77) 11%, rgb(240, 216, 168) 81%)'
    },
    goodsBackground: {
      backgroundColor: 'linear-gradient(111deg, rgb(251, 232, 199) 11%, rgb(243, 209, 144) 81%)'
    },
    priceBackground: {
      backgroundColor: '#623a05'
    },
    descBackground: {
      backgroundColor: '#60605f'
    },
    nameBackground: {
      backgroundColor: '#070707'
    },
    background: {
      backgroundColor: '#f4f4f4'
    }
  },
  sign: {
    title: `<h1 class="ql-align-center"><span>${ LangIdMap.SignTitle }</span></h1>`,
    desc: `<h5 class="ql-align-center"><span>${ LangIdMap.SignSubtitle }</span></h5>`,
    secondTitle: `<p class="ql-align-center"><span>${ LangIdMap.SignSecondTitle }</span></p>`,
    secondSubtitle: `<p class="ql-align-center"><span class="ql-size-normal">${ LangIdMap.SignSecondSubtitle }</span></p>`,
    buttonBackground: {
      backgroundColor: '#000'
    },
    buttonColor: {
      backgroundColor: '#fff'
    },
    doneBackground: {
      backgroundColor: '#a5a5a5'
    },
    repairBackground: {
      backgroundColor: '#ebc75c'
    }
  },
  inviteCode: {
    title: `<h1 class="ql-align-center"><span>${ LangIdMap.inviteCodeTitle }</span></h1>`,
    subtitle: `<h5 class="ql-align-center"><span class="ql-size-normal">${ LangIdMap.inviteCodeTitleSubtitle }</span></h5>`,
    rule: `<p class="ql-align-center"><span>${ LangIdMap.inviteCodeRule }</span></p>`
  },
  vipUser: {
    ruleTitle: `<p class="ql-align-center" style="color:#f5ce88;"><strong>kop-128</strong></p>`,
    ruleText: `<h3 class="ql-align-center"><span style="color: rgb(222, 186, 134);">${LangIdMap.vipUserRuleText1}</span></h3><p class="ql-align-center"><br></p><h3><span style="color: rgb(255, 255, 255);">${LangIdMap.vipUserRuleText2}</span></h3><p><span style="color: rgb(153, 153, 153);">${LangIdMap.vipUserRuleText3}</span></p><p><br></p><h3><span style="color: rgb(255, 255, 255);">${LangIdMap.vipUserRuleText4}</span></h3><p><span style="color: rgb(153, 153, 153);">${LangIdMap.vipUserRuleText5}</span></p><p><br></p><h3><span style="color: rgb(255, 255, 255);">${LangIdMap.vipUserRuleText6}</span></h3><p><span style="color: rgb(153, 153, 153);">${LangIdMap.vipUserRuleText7}</span></p><p><br></p><h3 class="ql-align-center"><span style="color: rgb(222, 186, 133);">${LangIdMap.vipUserRuleText8}</span></h3><p class="ql-align-center"><br></p><p><span style="color: rgb(153, 153, 153);">${LangIdMap.vipUserRuleText9}</span></p>`
  },
  pointStore: {
    title: `<p class="ql-align-center"><span style="color: rgb(0, 0, 0);">${LangIdMap.vipPointStoreTitle}</span></p>`
  },
  text: `<p class="ql-align-center">${LangIdMap.TextContent}</p>`,
  footer: {
    media: {
      title: LangIdMap.FooterMediaTitle,
      nav1Img: 'https://kopglobal.com/site-builder/prod/1702867363065_20231215-185054.png',
      nav2Img: 'https://kopglobal.com/site-builder/prod/1702867385029_20231215-185059.png',
      nav3Img: 'https://kopglobal.com/site-builder/prod/1702867411746_20231215-185102.png',
      nav4Img: 'https://kopglobal.com/site-builder/test/1734330946834_output.png',
      nav5Img: 'https://kopglobal.com/site-builder/test/1734331237130_youtube.png'
    },
    background: 'rgba(75, 75, 75, 1)',
    color: 'rgba(255, 255, 255, 1)',
    lineColor: 'rgba(255, 255, 255, 0.3)',
    logoBackground: {
      backgroundImage: 'https://kopglobal.com/site-builder/prod/1717748345717_7d7726b81554ded968ef4aff9c413731.png',
      backgroundSize: '100% 100%'
    }
  }
}
